// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '@/redux/authSlice';
import empresaReducer from '@/redux/empresaSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    empresa: empresaReducer,
  }
});
